var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n\t.st1{fill:#ffffff;}\n\t.st2{fill:#ffffff;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5392,
    y1: 25.5206,
    x2: 163.0757,
    y2: 25.5206,
    gradientTransform: "matrix(0.9905 0.1376 0.1376 -0.9905 -108.562 37.3777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#C7422F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#D46E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEB575"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,27.2c0-0.4,0.1-0.8,0.1-1.3c0.5-7.3-1-14.6-4.3-21.2L50.9,0l-1.1,5.2c-2.6,12.1-10.9,22.2-22.3,27.1 L25.9,33l0.6,1.7c2,5.4,2.8,11.1,2.2,16.8c-0.3,3.1-1,6.1-2,9L25.4,64l3.6-1.2C44.7,57.7,55.9,43.7,57.5,27.2z M33.2,57l-1.9,1 l0.4-2.1c0.3-1.4,0.5-2.8,0.6-4.2c0.5-5.4,0-10.8-1.6-16L30.5,35l0.8-0.4C40,30.2,46.9,22.9,50.8,14l1.2-2.8l0.7,2.9 c1,4.2,1.4,8.5,0.9,12.7C52.5,39.8,44.8,51.2,33.2,57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.0176,
    y1: 26.3145,
    x2: 155.7741,
    y2: 26.3145,
    gradientTransform: "matrix(0.9905 0.1376 0.1376 -0.9905 -108.562 37.3777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#CF603B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEB575"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.6,29.3c1.4-3.2,2.9-11.1,2.8-11.6c-1.5,2.8-3.2,5.4-5.2,7.8c-0.3,0.8-0.6,1.6-1,2.3l0,0 c-2.5,5.5-6.3,10.3-11,14.1c0.2,1.4,0.3,2.9,0.4,4.3C40.7,41.8,45.5,36,48.6,29.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0678,
    y1: 24.7564,
    x2: 149.8578,
    y2: 24.7564,
    gradientTransform: "matrix(0.9905 0.1376 0.1376 -0.9905 -108.562 37.3777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#CF603B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEB575"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.7,46.4c-3.4,1.6-7,2.7-10.7,3.2l-2.1,0.3l1.1-1.8c0.7-1.2,1.3-2.5,1.9-3.7c2.2-4.9,3.5-10.2,3.7-15.6 l0-0.9l0.9-0.1c6.8-0.9,13.2-3.5,18.8-7.5c2.9-3.4,5.1-7.4,6.5-11.6c-6.6,9.1-16.9,14.9-28.1,15.7l-1.8,0.1l0,1.8 c0.2,5.7-1,11.4-3.4,16.6c-1.3,2.8-2.9,5.5-4.8,7.9l-2.3,3l3.8,0c5.7,0.1,11.3-1,16.5-3.2C26.8,49.1,26.8,47.8,26.7,46.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDask);
export default __webpack_public_path__ + "static/media/dask.3d2ca7e8ba00d58f3ee399091c2baaa7.svg";
export { ForwardRef as ReactComponent };